import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface DaysOfWeekSelectorProps {
  selectedDays: number[];
  onDaysChange: (days: number[]) => void;
}

const DAYS = [
  { value: 0, label: 'Sunday', short: 'Sun' },
  { value: 1, label: 'Monday', short: 'Mon' },
  { value: 2, label: 'Tuesday', short: 'Tue' },
  { value: 3, label: 'Wednesday', short: 'Wed' },
  { value: 4, label: 'Thursday', short: 'Thu' },
  { value: 5, label: 'Friday', short: 'Fri' },
  { value: 6, label: 'Saturday', short: 'Sat' },
];

const DaysOfWeekSelector = ({ selectedDays, onDaysChange }: DaysOfWeekSelectorProps) => {
  const handleDayToggle = (dayValue: number, checked: boolean) => {
    if (checked) {
      onDaysChange([...selectedDays, dayValue].sort());
    } else {
      onDaysChange(selectedDays.filter(day => day !== dayValue));
    }
  };

  const toggleAll = () => {
    if (selectedDays.length === 7) {
      onDaysChange([]);
    } else {
      onDaysChange([0, 1, 2, 3, 4, 5, 6]);
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <Label className="text-sm font-medium">Days of Week</Label>
        <button
          type="button"
          onClick={toggleAll}
          className="text-xs text-blue-600 hover:text-blue-800"
        >
          {selectedDays.length === 7 ? 'Deselect All' : 'Select All'}
        </button>
      </div>
      
      <div className="grid grid-cols-2 gap-2">
        {DAYS.map((day) => (
          <div key={day.value} className="flex items-center space-x-2">
            <Checkbox
              id={`day-${day.value}`}
              checked={selectedDays.includes(day.value)}
              onCheckedChange={(checked) => handleDayToggle(day.value, checked as boolean)}
            />
            <Label 
              htmlFor={`day-${day.value}`} 
              className="text-sm font-normal cursor-pointer"
            >
              {day.label}
            </Label>
          </div>
        ))}
      </div>
      
      {selectedDays.length === 0 && (
        <p className="text-xs text-red-600 mt-2">Please select at least one day</p>
      )}
    </div>
  );
};

export default DaysOfWeekSelector;